import React from "react";

/**
 * אייקון מצה – ריבוע מעוגל עם חירורים אופייניים (כשר לפסח).
 */
export function MatzahIcon({ className = "w-4 h-4 text-amber-600", ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      {/* מצה עגולה */}
      <circle cx="12" cy="12" r="9" />
      {/* חירורים אופייניים למצה */}
      <circle cx="8" cy="8" r="0.8" fill="currentColor" />
      <circle cx="12" cy="8" r="0.8" fill="currentColor" />
      <circle cx="16" cy="8" r="0.8" fill="currentColor" />
      <circle cx="8" cy="12" r="0.8" fill="currentColor" />
      <circle cx="12" cy="12" r="0.8" fill="currentColor" />
      <circle cx="16" cy="12" r="0.8" fill="currentColor" />
      <circle cx="8" cy="16" r="0.8" fill="currentColor" />
      <circle cx="12" cy="16" r="0.8" fill="currentColor" />
      <circle cx="16" cy="16" r="0.8" fill="currentColor" />
    </svg>
  );
}

export default MatzahIcon;
